import {
    DeleteCustomerQuota,
    QueryAssginQuota,
    QueryCustomerQuota,
    QueryQuotaSub,
    QuerySaleUserByAreaId,
    QuerySubArea,
    QueryViewQuota,
    ScrollQuota,
    SubmitQuotaStatus,
    SubmitUpdateStatus,
    SubmitUserQuota,
    SubmitUserQuotaStatus,
    UpdateAbnormal,
    UpdateAssginQuota,
    UpdateCustomerQuota,
    UpdateUserQuota,
    UpdateViewQuota
} from '@/request/quota';
import {
    AssginAreaMonth,
    AssginBaseQuota,
    CreateAbnormal,
    DeleteAbnormal,
    MarkMessage,
    QueryAbnormalInfo,
    QueryAbnormalQuota
} from '../../request/quota';

export default {
    namespace: true,
    state: {
        quotaList: {},
        assginQuota: []
    },
    mutations: {
        SET_QUOTA_LIST(state, quotaList) {
            state.quotaList = quotaList;
        },

        SET_ASSGIN_QUOTA(state, assginQuota) {
            state.assginQuota = assginQuota;
        },

        SET_QUOTA_STATE(state, quotaList) {
            state.quotaList = quotaList;
        }
    },
    actions: {
        UPDATE_QUOTA_STATE: async ({ commit }, payload) => {
            commit('SET_QUOTA_STATE', payload);
        },

        QUERY_CUSTOMER_QUOTA: async ({ commit }, payload) => {
            let res = await QueryCustomerQuota(payload);
            if (res?.code == 200) {
                commit('SET_QUOTA_LIST', res.data ?? {});
            }
            return res;
        },

        UPDATE_CUSTOMER_QUOTA: async ({ commit }, payload) => {
            let res = await UpdateCustomerQuota(payload);
            return res;
        },

        DELETE_CUSTOMER_QUOTA: async ({ commit }, payload) => {
            let res = await DeleteCustomerQuota(payload);
            return res;
        },

        // 分配指标
        QUERY_ASSGIN_QUOTA: async ({ commit }, payload) => {
            let res = await QueryAssginQuota(payload);
            if (res?.code == 200) {
                commit('SET_ASSGIN_QUOTA', res.data ?? []);
            }
            return res;
        },

        UPDATE_ASSGIN_QUOTA: async ({ commit }, payload) => {
            let res = await UpdateAssginQuota(payload);
            return res;
        },

        QUERY_SALE_USER_BY_AREA_ID: async ({ commit }, payload) => {
            let res = await QuerySaleUserByAreaId(payload);
            return res;
        },

        QUERY_VIEW_QUOTA: async ({ commit }, payload) => {
            let res = await QueryViewQuota(payload);
            return res;
        },

        UPDATE_VIEW_QUOTA: async ({ commit }, payload) => {
            let res = await UpdateViewQuota(payload);
            return res;
        },
        SUBMIT_QUOTA_STATUS: async ({ commit }, payload) => {
            let res = await SubmitQuotaStatus(payload);
            return res;
        },
        SUBMIT_UPDATE_STATUS: async ({ commit }, payload) => {
            let res = await SubmitUpdateStatus(payload);
            return res;
        },

        UPDATE_USER_QUOTA: async ({ commit }, payload) => {
            let res = await UpdateUserQuota(payload);
            return res;
        },

        SUBMIT_USER_QUOTA: async ({ commit }, payload) => {
            let res = await SubmitUserQuota(payload);
            return res;
        },

        SUBMIT_USER_QUOTA_STATUS: async ({ commit }, payload) => {
            let res = await SubmitUserQuotaStatus(payload);
            return res;
        },

        //下属指标
        QUERY_QUOTA_SUB: async ({ commit }, payload) => {
            let res = await QueryQuotaSub(payload);
            return res;
        },

        SCROLL_QUOTA: async ({ commit }, payload) => {
            let res = await ScrollQuota(payload);
            return res;
        },

        // 下级区域
        QUERY_SUB_AREA: async ({ commit }, payload) => {
            let res = await QuerySubArea(payload);
            return res;
        },

        ASSGIN_AREA_MONTH: async ({ commit }, payload) => {
            let res = await AssginAreaMonth(payload);
            return res;
        },

        QUERY_ABNORMAL_QUOTA: async ({ commit }, payload) => {
            let res = await QueryAbnormalQuota(payload);
            return res;
        },
        MARK_MESSAGE: async ({ commit }, payload) => {
            let res = await MarkMessage(payload);
            return res;
        },
        CREATE_ABNORMAL: async ({ commit }, payload) => {
            let res = await CreateAbnormal(payload);
            return res;
        },
        UPDATE_ABNORMAL: async ({}, payload) => {
            let res = await UpdateAbnormal(payload);
            return res;
        },
        DELETE_ABNORMAL: async ({ commit }, payload) => {
            let res = await DeleteAbnormal(payload);
            return res;
        },
        QUERY_ABNORMAL_INFO: async ({ commit }, payload) => {
            let res = await QueryAbnormalInfo(payload);
            return res;
        },

        ASSGIN_BASE_QUOTA: async ({ commit }, payload) => {
            let res = await AssginBaseQuota(payload);
            return res;
        }
    }
};
